import WebsocketManager from "./WebsocketManager";

class WebSocketConnectionClass {
  constructor() {
    this.url = undefined;
    this.token = undefined;
    this.webSocket = undefined;
    this.eventListeners = [];
    this.reconnectListeners = [];
    this.closeEventListeners = [];
    this.websocketManager = undefined;
    this.closed = true;
  }

  addWebsocketListeners = (eventName, func) => {
    this.eventListeners.push({ key: eventName, func });
  };

  addWebsocketCloseListeners = func => {
    this.closeEventListeners.push(func);
  };

  addWebsocketReconnectListeners = func => {
    this.reconnectListeners.push(func);
  };

  async init(url, token) {
    this.url = url;
    this.token = token;
    this.websocketManager = new WebsocketManager(this);
    await this.newWebsocketConnection();
    this.websocketManager.init();
  }

  newWebsocketConnection() {
    return new Promise(resolve => {
      const protocol = this.url.includes("://") ? "" : "wss://";
      const string = encodeURI(`${protocol}${this.url}${this.token}`);
      this.webSocket = new WebSocket(string);
      this.webSocket.onopen = () => {
        this.closed = false;
        resolve();
      };
    }).then(this.initializeWebsocket(this.webSocket));
  }

  initializeWebsocket(ws) {
    ws.onclose = e => this.onClose(e);
    ws.onerror = e => this.onError(e);
    ws.onmessage = this.onMessage;
  }

  onMessage = event => {
    const json = JSON.parse(event.data);
    const triggeredEventListeners = this.eventListeners.filter(object => object.key === json.cmd);
    triggeredEventListeners.forEach(eventListener => eventListener.func(json));
    this.websocketManager.gotMessage();
  };

  onError() {
    this.webSocket.close();
  }

  onClose() {
    this.webSocket = undefined;
    this.closed = true;
    setTimeout(async () => {
      this.reconnectListeners.forEach(listener => listener());
      await this.websocketManager.reconnect().catch(() => {
        this.closeEventListeners.forEach(listener => listener());
      });
    }, 5000);
  }

  updateToken(token) {
    this.token = token;
  }

  send(message) {
    return new Promise((resolve, reject) => {
      if (!this.closed) {
        try {
          this.webSocket.send(JSON.stringify(message));
          resolve();
        } catch {
          reject();
        }
      }
    });
  }
}

let instance = null;
const websocketSingleton = {
  getInstance: () => {
    if (!instance) instance = new WebSocketConnectionClass();
    return instance;
  },
};
export default websocketSingleton;
